import React from "react";
import Select from "react-select";

const CustomSelect = ({
  value,
  getOptionLabel,
  getOptionValue,
  autoload,
  isLoading,
  isDisabled,
  options,
  placeholder,
  onChange,
  onFocus,
  isInvalid,
  message,
  normal,
  width,
  filterOption,
}) => {
  const customSelectStyle = {
    control: (provided, state) => ({
      ...provided,
      height: "42px",
      borderColor: isInvalid
        ? "#E53E3E"
        : isDisabled
        ? "#666"
        : "rgb(204, 204, 204)",
      width: width && width,
      backgroundColor: isDisabled ? "#dbdbdb" : "#FFF",
      opacity: isDisabled ? 0.7 : 1,
      whiteSpace: normal ? "normal" : "nowrap",
      overflow: "hidden",
    }),
    menu: (provided, state) => ({
      ...provided,
      "z-index": 3,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: isDisabled ? "#000" : "rgb(51, 51, 51)",
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: isDisabled ? "#000" : "rgb(204, 204, 204)",
    }),
  };

  return (
    <Select
      data-testid="custom-select"
      loadingMessage={() => "Carregando..."}
      noOptionsMessage={() => (message ? message : "Sem opções")}
      value={value}
      searchable={true}
      isClearable={true}
      getOptionLabel={getOptionLabel || ((option) => option.label)}
      getOptionValue={getOptionValue || ((option) => option.value)}
      autoload={autoload && true}
      isLoading={!!isLoading}
      isDisabled={!!isDisabled}
      options={options}
      placeholder={placeholder}
      styles={customSelectStyle}
      onChange={onChange}
      onFocus={onFocus}
      filterOption={filterOption}
    />
  );
};

export default CustomSelect;
